import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

var TvkosiceWidget = createReactClass({
  propTypes: {
    index: PropTypes.number,
    uri: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    uuid: PropTypes.string,
    changeObject: PropTypes.func,
    contentSpace: PropTypes.string,
  },

  getDefaultProps() {
    return {
      index: 0,
      uri: '',
      width: '',
      height: '',
      uuid: '',
      changeObject: function() {},
    };
  },

  getInitialState() {
    return {
      uri: '',
      width: this.props.width || '',
      height: this.props.height || '',
    };
  },

  didRemoveWidget() {
    this.props.didRemoveWidget(this.props.index);
  },

  moveWidgetUp() {
    this.props.moveWidget(this.props.index, 'up');
  },

  moveWidgetDown() {
    this.props.moveWidget(this.props.index, 'down');
  },

  onChangeUrl(event) {
    var value = event.target.value;
    var object = this.getWidgetObject();
    object.uri = value;
    this.props.changeObject(this.props.index, object);
  },

  onChangeWidth(event) {
    var value = event.target.value;
    var object = this.getWidgetObject();
    object.width = value;
    this.props.changeObject(this.props.index, object);
  },

  onChangeHeight(event) {
    // nastavime height vo widgete v parentovy
    var value = event.target.value;
    var object = this.getWidgetObject();
    object.height = value;
    this.props.changeObject(this.props.index, object);
  },

  getWidgetObject() {
    return {
      type: 'tvkosice',
      uri: this.props.data.uri,
      width: this.props.width,
      height: this.props.height,
      uuid: this.props.uuid,
    };
  },

  render() {
    return (
      <div
        data-index={this.props.index}
        style={{ clear: 'both' }}
        className="panel panel-default widget-body"
      >
        <div className="panel-heading">
          <div className="btn-group">
            <button
              className="btn btn-default btn-sm"
              onClick={this.moveWidgetUp}
              disabled={this.props.index === 0}
            >
              <i className="fa fa-arrow-up" />
            </button>
            <button
              className="btn btn-default btn-sm"
              onClick={this.moveWidgetDown}
              disabled={this.props.isLast}
            >
              <i className="fa fa-arrow-down" />
            </button>
          </div>
          <span className="panel-title">
            <strong> {this.props.name}</strong>
          </span>
          <a
            onClick={this.didRemoveWidget}
            href="javascript:void(0);"
            className="btn btn-danger btn-sm pull-right"
          >
            <i className="fa fa-times" />
          </a>
        </div>
        <div className="panel-body">
          <input
            onChange={this.onChangeUrl}
            value={this.props.data.uri}
            className="form-control"
            type="text"
            placeholder="https://www.tvkosice.sk/video/..."
            name="widget-youtube"
          />
          <div style={{ clear: 'both' }} />
        </div>
      </div>
    );
  },
});

export default TvkosiceWidget;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/ArticleWidgets/ArticleTvkosiceWidget.jsx